import { b as a } from "./chunk.DHZ1xb2E.js";
const { color: r } = a, s = {
  background: {
    primary: r.grey[50],
    secondary: r.white
  },
  border: {
    highContrast: r.white,
    colorEnabled: r.primary[500],
    colorHover: r.primary[600],
    colorPressed: r.primary[700],
    colorFocused: r.primary[500],
    neutralEnabled: r.grey[200],
    disabled: r.grey[400],
    highEmphasis: r.transparent.black50p,
    mediumEmphasis: r.transparent.black26p,
    lowEmphasis: r.transparent.black10p,
    error: r.functional[303]
  },
  surface: {
    colorEnabled: r.primary[500],
    colorHover: r.primary[600],
    colorPressed: r.primary[700],
    colorContrast: r.primary[800],
    transparentHover: r.transparent.black8p,
    transparentPressed: r.transparent.black20p,
    disabled: r.grey[300],
    selected: r.transparent.primary8,
    selectedHover: r.transparent.primary15,
    selectedPressed: r.transparent.primary20
  },
  typography: {
    highEmphasis: r.grey[900],
    mediumEmphasis: r.grey[700],
    lowEmphasis: r.grey[600],
    highContrast: r.white,
    interactiveEnabled: r.primary[500],
    interactiveHover: r.primary[600],
    interactivePressed: r.primary[700],
    disabled: r.grey[400]
  }
};
export {
  s as c
};
